import styled from "styled-components";

const DropDownBundle = styled.div`
  --svg-size: 20px;
  font-family: var(--font-DINNextLTPro-MediumCond);

  position: relative;
  height: 100%;
  z-index: 2;
  
  @media (max-width: 859px) {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  @media (min-width: 860px) {
    margin-right: 10px;
  }

  .dropdown-sort__button {
    background-color: ${({theme}) => theme.colors.bundleBlack};
    @media (max-width: 859px) {
      width: 100%;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    @media (min-width: 860px) {
      padding-top: .5rem;
      padding-bottom: .5rem;
      padding-left: 8px;
    }
  }

  .dropdown-sort__title {
    font-size: 26px;
    color: ${({theme}) => theme.colors.bundleWhite};
    margin-right: 4px;
    text-transform: uppercase;
    font-family: var(--font-DINNextLTPro-Regular);
  };

  .dropdown-sort__menu {
    border: 1px solid ${({theme}) => theme.colors.gray2};
    padding: .5rem 23px;
    line-height: 2.3;
    position: absolute;
    background-color: ${({theme}) => theme.colors.bundleWhite};
    color: ${({theme}) => theme.colors.bundleBlack};
    font-family: var(--font-DINNextLTPro-Regular);

    @media (max-width: 859px) {
      width: calc(100% + 1px);
      top: 100%;
      left: 0;
    }
    @media (min-width: 860px) {
      top: 36px;
      right: 0;
    }
  }
  
  .dropdown-sort__header {
    @media (max-width: 859px) {
      display: none;
    }
    @media (min-width: 860px) {
      display: flex;
      align-items: baseline;
    }
  }

  .dropdown-sort__heading {
    @media (max-width: 859px) {
      display: none;
    }
    @media (min-width: 860px) {
      color: ${({theme}) => theme.colors.gray4};
    }
  }

  .dropdown-sort__radio {
    padding-top: .125rem;
    padding-bottom: .125rem;
    width: 100%;
    min-width: 108px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    cursor: pointer;
    transition: var(--button-transition);
    svg {
      rect {
        stroke: ${({theme}) => theme.colors.bundleBlack};
      }
    }
 
    &.is-checked {
      color: ${({theme}) => theme.colors.bundleGold};
    }
    
    &:hover {
      span {
        color: ${({theme}) => theme.colors.bundleGold};
      }
      svg {
        rect {
          stroke: ${({theme}) => theme.colors.bundleGold};
        }
      }       
  }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;

      &:checked ~ .dropdown-sort__radio__custom {
        background-color: ${({theme}) => theme.colors.brandDark};
        border-color: ${({theme}) => theme.colors.brandDark};
      }
    }
  }

  .dropdown-sort__radio__custom {
    position: relative;
    height: 16px;
    width: 16px;
    background-color: transparent;
    border: 2px solid ${({theme}) => theme.colors.gray2};
    border-radius: 50%;

    &::after {
      position: absolute;
      content: "";
      border-radius: 0;
    }
  }

  .dropdown-sort__radio__copy {
    margin-left: 8px;
  }

  .dropdown-sort__icon {
    fill: ${({theme}) => theme.colors.brandDark};
    height: 12px;
    width: 12px;
    transition: transform 0.5s;
    
    &.isOpen {
      transform: rotate(-180deg);
    }
    &.isClosed {
    }
  }

  .filter-product-type__checkbox__custom {
    position: relative;
    height: 14px;
    width: 14px;
    flex-shrink: 0;
    margin-bottom: 2px;
    margin-right: 8px;
  };

  .filter-check-arrow {
    position: absolute;
    top: -9px;
    left: -3px;
    width: 23px;
    height: 23px;
  };

  .filter-check-square {
    width: 16px;
    height: 16px;
    border: 2px solid ${({ theme }) => theme.colors.bundleBlack};
    border-radius: 5px;
  };

`;

export default DropDownBundle;